<template>
  <div class="page-container">
    <div class="section-top section-top-lg">
      <div class="title-holder">
        <a v-bind:href="'#/Catalog/' + urlParentId()" class="link-back">
          <i class="icon icon-arrow-back"></i>
        </a>
        <Loader v-if="loading" />
        <h1 v-else class="title">
          <span class="title-item">{{ titleNameCat }}</span>
        </h1>
      </div>
      <div
        class="sort-holder title-filter-list"
        v-if="this.id == 59 && powerRanges.length > 0"
      >
        <ul class="sort-list">
          <li class="sort-list-item" v-bind:class="{ active: disabled === 0 }">
            <span class="sort-list-item-link" v-on:click="disabled = 0"
              >Всі</span
            >
          </li>
          <li
            v-for="(range, index) in powerRanges"
            :key="index"
            class="sort-list-item"
            v-bind:class="{ active: disabled === index + 1 }"
          >
            <span class="sort-list-item-link" v-on:click="disabled = index + 1"
              >{{ range.from }}-{{ range.to }} к.с.</span
            >
          </li>
        </ul>
      </div>
    </div>
    <Loader v-if="loading" />
    <div v-else class="section-main catalog-main-section">
      <div class="sub-catalog-list">
        <div
          class="sub-catalog-item"
          v-for="product in productsFilter"
          :key="product.id"
        >
          <div v-if="product.category_id === id">
            <div class="sub-catalog-item__img">
              <a v-bind:href="'#/CatalogDetail/' + id + '/' + product.id">
                <img
                  style="margin: -20% 0px;"
                  v-bind:src="product.preview_img"
                  v-bind:alt="product.name"
                />
              </a>
            </div>
            <div class="sub-catalog-item__info">
              <div class="sub-catalog-item__name">
                <a v-bind:href="'#/CatalogDetail/' + id + '/' + product.id">{{
                  product.name
                }}</a>
              </div>
              <div
                class="info-list"
                v-for="(property, index) in product.property2"
                :key="property.id"
              >
                <div v-if="index <= 1">
                  <div
                    class="info-list__row"
                    v-for="(prop, indexs) in property"
                    :key="prop.id"
                  >
                    <div class="info-list__title">{{ indexs }}:</div>
                    <div
                      class="info-list__value"
                      v-for="value in prop"
                      :key="value.id"
                    >
                      {{ value }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
module.exports = {
  data () {
    return {
      noFilter: true,
      isActive: true,
      disabled: 0,
      category: Object,
      products: Object,
      titleName: '',
      loading: true,
      errored: false,
      id: this.$route.params['id']
    }
  },
  computed: {
    titleNameCat: function () {
      this.titleName = this.category.name
      return this.titleName
    },
    productPowers () {
      if (!Array.isArray(this.products)) return []
      return this.products.map(item => ({
        id: item.id,
        power: this.extractPower(item)
      }))
    },
    powerGroups () {
      const items = this.productPowers
        .filter(p => typeof p.power === 'number' && !isNaN(p.power))
        .slice()
        .sort((a, b) => a.power - b.power)
      if (items.length < 2) return []
      if (items[0].power === items[items.length - 1].power) return []
      const total = items.length
      const groupCount = Math.min(3, total)
      const groups = []
      for (let i = 0; i < groupCount; i++) {
        const start = Math.floor((i * total) / groupCount)
        const end = Math.floor(((i + 1) * total) / groupCount)
        const slice = items.slice(start, end)
        if (slice.length === 0) continue
        groups.push({
          from: slice[0].power,
          to: slice[slice.length - 1].power,
          ids: slice.map(s => s.id)
        })
      }
      return groups
    },
    powerRanges () {
      return this.powerGroups.map(g => ({
        from: Math.floor(g.from),
        to: Math.ceil(g.to)
      }))
    },
    productsFilter () {
      if (!Array.isArray(this.products)) return []
      if (this.disabled === 0) return this.products
      const group = this.powerGroups[this.disabled - 1]
      if (!group) return this.products
      const idSet = new Set(group.ids)
      return this.products.filter(item => idSet.has(item.id))
    }
  },
  methods: {
    extractPower (product) {
      if (!product || !Array.isArray(product.property2)) return null
      for (const entry of product.property2) {
        for (const key in entry) {
          const values = entry[key]
          if (!Array.isArray(values)) continue
          for (const value of values) {
            const match = String(value).match(
              /(\d+(?:[.,]\d+)?)\s*к\.?\s*с\.?/i
            )
            if (match) return parseFloat(match[1].replace(',', '.'))
          }
        }
      }
      return null
    },
    loadJsonCategories () {
      this.categoriesJson
        .get()
        .then(response => response.json())
        .then(response => {
          this.category = response
        })
    },
    async loadJsonProducts () {
      await this.productsJson
        .get()
        .then(response => response.json())
        .then(response => {
          this.products = response
        })
      this.loading = false
    },
    urlParentId () {
      return this.category.parent
    }
  },
  mounted () {
    this.loadJsonCategories()
    this.loadJsonProducts()
  },
  created () {
    if (localStorage.getItem('activeItem') === '1') {
      this.categoriesJson = this.$resource(
        'categories/ua/' +
          this.id +
          '&token=' +
          localStorage.userToken +
          '&id=' +
          localStorage.userId
      )
      this.productsJson = this.$resource(
        'products/ua&category=' +
          this.id +
          '&token=' +
          localStorage.userToken +
          '&id=' +
          localStorage.userId
      )
    } else {
      this.categoriesJson = this.$resource(
        'categories/' +
          this.id +
          '&token=' +
          localStorage.userToken +
          '&id=' +
          localStorage.userId
      )
      this.productsJson = this.$resource(
        'products&category=' +
          this.id +
          '&token=' +
          localStorage.userToken +
          '&id=' +
          localStorage.userId
      )
    }
  }
}
</script>
